export enum SearchableField {
  SEARCHABLE_FIELD_UNSPECIFIED = 0,
  SEARCHABLE_FIELD_COMPANY_NAME = 1,
  SEARCHABLE_FIELD_COMMON_NAME = 2,
  SEARCHABLE_FIELD_ADDRESS = 3,
  SEARCHABLE_FIELD_ADDRESS_2 = 4,
  SEARCHABLE_FIELD_CITY = 5,
  SEARCHABLE_FIELD_STATE = 6,
  SEARCHABLE_FIELD_ZIP = 7,
  SEARCHABLE_FIELD_COUNTRY = 8,
  SEARCHABLE_FIELD_WORK_NUMBER = 9,
  SEARCHABLE_FIELD_SOCIAL_PROFILE_ID = 10,
  SEARCHABLE_FIELD_CUSTOMER_ID = 11,
  SEARCHABLE_FIELD_ACCOUNT_GROUP_ID = 12,
}

export interface SearchOptions {
  fields?: SearchableField[];
}
